import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule, MatDialogModule, MatSliderModule, MatProgressSpinnerModule, MatIconModule, MatTooltipModule, MatCardModule, MatCheckboxModule } from '@angular/material';
import { ImageEditorComponent } from './image-editor/image-editor.component';
import { ImageEditorDialogComponent } from './image-editor-dialog';

@NgModule({
  declarations: [
    ImageEditorComponent,
    ImageEditorDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatSliderModule,
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatCardModule,
    MatCheckboxModule
  ],entryComponents: [ImageEditorDialogComponent],
  exports: [ImageEditorComponent]
})
export class ImageEditorModule {}
